import * as Yup from "yup";
import YupPassword from "yup-password";
YupPassword(Yup);

const validationMessage = {
  notvalid: "please enter in valid way!",
  required: "Required!",
  start: "First Letter should be Capital Letter",
  whitespace: "There are no whitespace allowed",
  tooShort: "Too Short!",
  tooLong: "Too Long!",
};

const regexr = {
  charandspace: /^[A-Za-z]+[\s]*$/,
  startWithCapital: /^[A-Z]/,
  website:
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
};

export const SignupSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, validationMessage.tooShort)
    .max(50, validationMessage.tooLong)
    .matches(regexr.charandspace, validationMessage.notvalid)
    .matches(regexr.startWithCapital, validationMessage.start)
    .required(validationMessage.required),

  lastName: Yup.string()
    .min(2, validationMessage.tooShort)
    .max(50, validationMessage.tooLong)
    .matches(regexr.charandspace, validationMessage.notvalid)
    .matches(regexr.startWithCapital, validationMessage.start)
    .required(validationMessage.required),

  email: Yup.string()
    .email("Invalid email")
    .required(validationMessage.required),

  password: Yup.string()
    .min(8, "Password is too short - should be 8 chars minimum.")
    .max(25, "Password is too long - should be up to 25 chars maximum.")
    .matches(/[a-zA-Z]/, "Password can only contain Latin letters.")
    .minLowercase(2, "password must contain at least 2 lower case letter")
    .minUppercase(2, "password must contain at least 2 upper case letter")
    .minNumbers(2, "password must contain at least 2 digit number")
    .minSymbols(2, "password must contain at least 2 special character")
    .required(validationMessage.required),

  cpassword: Yup.string()
    .required(validationMessage.required)
    .oneOf([Yup.ref("password"), null], "Passwords must match"),

  dob: Yup.date()
    .test(
      "dob",
      "enter birthdate in a such manner so that age Should be between 18 and less than 60!",
      function (value, createerr) {
        const dob = new Date(value);
        const validDate = new Date();
        const diff = validDate.getFullYear() - dob.getFullYear();
        const valid = diff >= 18 && diff <= 60;
        return !valid ? createerr.createError() : valid;
      }
    )
    .required("required"),

  phone: Yup.number().required("A phone number is required"),

  gender: Yup.string().required("please select gender!"),

  role: Yup.string().required("please select your role!"),

  website: Yup.string().matches(regexr.website, "enter valid url"),

  file: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "This file is too large",
      (file) =>
        //1kb = 1024bytes //1mb = 1024kb
        !file || (file && file.size <= 1024 * 1024)
    )
    .test(
      "fileType",
      "Only the .jpeg, .jpg, .png format file accpeted",
      (file) =>
        !file || ["image/png", "image/jpg", "image/jpeg"].includes(file?.type)
    )
    .required("Please add profile photo!"),

  country: Yup.string().required("please select your country!"),

  address: Yup.object().shape({
    state: Yup.string().required("Please select state"),
    city: Yup.string().required("please select City!"),
  }),
});
